let apiHosts = {
    authorization: 'https://api-projects-authorization.instantdesigntool.com',
    project: 'https://api-projects.instantdesigntool.com',
    publicAssets: 'https://api-assets-public.instantdesigntool.com',
    privateAssets: 'https://api-assets-private.instantdesigntool.com',
    resources: 'https://api-resources.instantdesigntool.com',
    functions: 'https://editor-functions.instantdesigntool.com',
    tenant: 'https://api.instantdesigntool.com'
};

// The `if` branches below are interpreted at build time. The dev and staging URLs are
// not included in the production build.

if (process.env.REACT_APP_ENV === 'staging') {
    apiHosts = {
        authorization: 'https://gift-api-projects-authorization-staging.azurewebsites.net',
        project: 'https://gift-api-projects-staging.azurewebsites.net',
        publicAssets: 'https://gift-api-assets-public-staging.azurewebsites.net',
        privateAssets: 'https://gift-api-assets-private-staging.azurewebsites.net',
        resources: 'https://gift-api-resources-staging.azurewebsites.net',
        functions: 'https://gift-functions-staging.azurewebsites.net',
        tenant: 'https://gift-api-output-staging.azurewebsites.net'
    };
}

if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development') {
    apiHosts = {
        authorization: 'https://api-projects-authorization.local:18004',
        project: 'https://api-project.local:18001',
        publicAssets: 'https://api-assets-public.local:18002',
        privateAssets: 'https://api-assets-private.local:18005',
        resources: 'https://api-resources.local:18009',
        functions: 'https://functions.local:18013',
        tenant: 'https://api.local:18003'
    };
}

export const urls = {
    requestNewGrant: `${apiHosts.authorization}/grants/new`,
    requestExistingGrant: `${apiHosts.authorization}/grants/existing`,
    pushProject: `${apiHosts.project}/projects/push`,
    openProject: `${apiHosts.project}/projects/open`,
    listPublicAssets: (type: string) => `${apiHosts.publicAssets}/assets?type=${type}`,
    loadPublicAsset: (id: string, locale: string) => `${apiHosts.functions}/api/public-assets/${id}/${locale}`,
    loadCollection: (id: string) => `${apiHosts.publicAssets}/collections/${id}`,
    loadResource: (id: string) => `${apiHosts.resources}/resources/${id}`,
    listResources: (id: string, type: string) => `${apiHosts.resources}/resources?sceneId=${id}&type=${type}`,
    publicAssetUrl: (id: string) => `${apiHosts.functions}/api/public-assets/${id}`,
    privateAssetsBaseUrl: apiHosts.functions,
    oldPrivateAssetsBaseUrl: apiHosts.privateAssets,
    uploadPrivateAsset: `${apiHosts.functions}/api/private-assets`,
    privateAssetUrl: (id: string) => `${apiHosts.functions}/api/private-assets/${id}`,
    createExternalUploader: `${apiHosts.functions}/api/external-uploader/create`,
    pollExternalUploads: `${apiHosts.functions}/api/external-uploader/poll`,
    listExternalUploaders: `${apiHosts.functions}/api/external-uploader/list`,
    createQrArPreview: `${apiHosts.functions}/api/ar-preview/create`,
    completeJob: (snapshotId: string, pipelineName: string) => `${apiHosts.tenant}/jobs/${snapshotId}/${pipelineName}`
};